<nz-card class="quota-panel">
  <h4 nz-typography class="nfl-form-label">Allocation Information</h4>

  <div class="usage-tip">
    <span nz-icon nzType="info-circle" nzTheme="twotone" class="usage-tip-icon"></span>
    <span class="usage-tip-text">
      <strong>Usage Tips:</strong> Use the filter icon in any column to refine the data by selecting one or more values
      from the available options, and click any column header to sort the table in ascending or descending order.
    </span>
  </div>

  <div class="usage-tip data-refresh-schedule">
    <span nz-icon nzType="info-circle" nzTheme="twotone" class="usage-tip-icon"></span>
    <span class="usage-tip-text">
      <strong>Data Refresh Information:</strong> Allocation usage data is refreshed periodically and may be delayed by 2
      to 3 days.
    </span>
  </div>

  <nz-table
    #allocationTable
    [nzData]="filteredData"
    nzBordered
    nzSize="middle"
    [nzScroll]="{ x: 'max-content' }"
    [nzFrontPagination]="true"
    [nzLoading]="isLoading"
    [nzTotal]="totalCount"
    [nzPageIndex]="pageIndex"
    [nzPageSize]="pageSize"
    (nzPageIndexChange)="onPageIndexChange($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"
    nzShowSizeChanger
  >
    <thead>
      <tr>
        <th
          *ngFor="let header of headers"
          nzShowSort
          [nzCustomFilter]="header.searchable"
          [nzShowFilter]="header.filterable !== false"
          [nzWidth]="header.width ?? null"
          [nzSortFn]="header.sortFn"
          [nzFilters]="header.filters"
          [nzFilterMultiple]="true"
          [nzFilterFn]="header.filterFn"
        >
          {{ header.label }}
          <nz-filter-trigger
            *ngIf="header.searchable"
            [nzVisible]="isTextFilterVisible(header.key)"
            (nzVisibleChange)="setTextFilterVisibility(header.key, $event)"
            [nzActive]="!!textFilters[header.key]"
            [nzDropdownMenu]="textFilterMenu"
          >
            <span nz-icon nzType="search"></span>
          </nz-filter-trigger>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of allocationTable.data">
        <td *ngFor="let header of headers">{{ getValue(row, header.key) }}</td>
      </tr>
    </tbody>
  </nz-table>

  <nz-dropdown-menu #textFilterMenu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <div class="search-box">
        <input
          nz-input
          nzSize="small"
          [attr.aria-label]="'Filter ' + getActiveTextFilterLabel()"
          [placeholder]="'Search ' + getActiveTextFilterLabel()"
          [ngModel]="getActiveTextFilterValue()"
          (ngModelChange)="setActiveTextFilterValue($event)"
          type="text"
          (keyup.enter)="applyActiveTextFilter()"
        />
        <button nz-button nzSize="small" nzType="primary" class="search-button" (click)="applyActiveTextFilter()">
          Search
        </button>
        <button nz-button nzSize="small" (click)="resetActiveTextFilter()">Reset</button>
      </div>
    </div>
  </nz-dropdown-menu>
</nz-card>
